/* eslint-disable radix */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import {
  getAllTrikesV3,
  getTrikesKPI,
  getTrikesV3,
  unretireTrike,
} from "../../../Redux/APIs/trikesAPI";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import { DEFAULT_LIMIT } from "../../../Utils/constants";
import UnRetireIcon from "../../../Common/Svgs/UnRetireIcon";

const UnretireTrikeModal = ({
  visible,
  onCancel,
  trikeCurrentPage,
  setTrikeCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { unretireTrikeModal } = useSelector((state) => state.trikes);

  const onConfirm = async () => {
    await dispatch(unretireTrike({ trikeId: unretireTrikeModal.id }));

    const response = await dispatch(
      getTrikesV3({
        offset: ((trikeCurrentPage || 1) - 1) * DEFAULT_LIMIT,
        limit: DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && trikeCurrentPage > 1) {
      const previousPage = trikeCurrentPage - 1;
      setTrikeCurrentPage(previousPage);

      await dispatch(
        getTrikesV3({
          offset: (previousPage - 1) * DEFAULT_LIMIT,
          limit: DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(getTrikesKPI());
    dispatch(getAllTrikesV3());

    dispatch(
      updateTrikes({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Trike un-retired.",
            description: `Trike ${
              unretireTrikeModal?.registrationNo || "1 trike"
            } was un-retired successfully.`,
          },
        },
      }),
    );

    onCancel();
  };

  const getBody = () => {
    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-black font-poppins">
          Un-Retire this trike
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to un-retire this trike?
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<UnRetireIcon size={24} className="text-white" />}
            background="bg-primary"
          />

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <Button colors="primary" size="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UnretireTrikeModal;
